<template>
    <button class="share-button" @click="shareDeal">
        <span class="material-symbols-outlined play-icon">share</span>
        Share Deal
    </button>
</template> 

<script setup lang="ts">
import util from '@/helpers/util'
import ga from '@/helpers/ga'
import clicky from '@/helpers/clicky'


interface Props {
    link: string,   
    messageTitle?: string,
    messageText?: string
}

const props = withDefaults(defineProps<Props>(), {
    messageTitle: 'Check out this deal!',
    messageText: 'I found this great deal and thought you might be interested!'
})

const shareDeal = async () => {
    await util.shareLink(props.link, props.messageTitle, props.messageText)

    ga.event('click', { 'event_category': 'sharelink', 'event_label': props.link })
    clicky.log('Share Link:' + props.link, 'click')

}

</script>